import { PhoneNumber } from "../types/phoneNumber"
import { StringFormatter } from "./stringFormatter"

/**
 *  A formatter that is useful for formatting the phone number as a plain string without
 *  any spaces or special characters. This might be useful for providing a phone number
 *  to a link or dialing mechanism.
 */
export class PhoneNumberPlainFormatter extends StringFormatter<PhoneNumber> {
  protected convert(input: PhoneNumber): string {
    return input.toString()
  }
}
